import create from 'zustand';

type Store = {
  T_M: boolean;//柵用20230412追記
  trueT_M: () => void;
  falseT_M: () => void;
  Start_Day: string|null;//柵用20230412追記
  setS_D: (Start_Day: string|null) => void;
  End_Day: string|null;//柵用20230412追記
  setE_D: (Pages: string|null) => void;
};

/**
 * 検索結果管理ストア
 */
const useEditData = create<Store>(set => ({
  T_M: false,//柵用20230412追記
  trueT_M:() => set({T_M: true}),
  falseT_M:() => set({T_M: false}),
  Start_Day:null,
  setS_D: Start_Day => set({Start_Day: Start_Day}),
  End_Day:null,
  setE_D: End_Day => set({End_Day: End_Day}),
}));

export default useEditData;